module.exports = __webpack_public_path__ + "img/a.9e80f684.png";